import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class WorkInstructionsRoute extends AuthenticatedRoute {}
